export enum EdenMessagesGridType {
  TaskBasedEdenMessages = 0,
  RegardingBasedEdenMessages = 1,
}

export interface EdenMessagesGridProps {
  edenMessagesType: EdenMessagesGridType;
  profileNumber: string;
  taskId?: string;
  regardingObjectId?: string;
}
